
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API from "../Services/MemberShip";
import APIS from "../Services/Auth";
import TaxRateListList from "../Components/TaxRate";
import moment from "moment";
import MemberShipList from "./MemberShipList";
import PlayPoint from "../Services/PlayPoint";
const MemberShip = () => {
    const [name, setName] = useState("");
    const [duration, setDuration] = useState([]);
    const [eligibilityCriteria, setEligibilityCriteria] = useState("");
    const [taxRateData, setTaxRateData] = useState("");
    const [descriptionOne, setDescriptionOne] = useState("");
    const [descriptionTwo, setDescriptionTwo] = useState("");
    const [error, setError] = useState({});
    const [selectedDuration, setSelectedDuration] = useState("");
    const [logoPreview, setLogoPreview] = useState(null);
    const [logo, setLogo] = useState("");
    const [discount, setDiscount] = useState("");
    const [loyaltyPoint, setLoyaltyPoint] = useState("");
    const [spent, setSpent] = useState("")
    const [bonusloyalty, setBonusloyalty] = useState("");
    const [skyCoins,setSkyCoins]=useState("");
    useEffect(() => {
        getDurationList();
    }, []);

    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "name":
                setName(value);
                break;

            case "eligibilityCriteria":
                setEligibilityCriteria(value);
                break;
            case "selectedDuration":
                setSelectedDuration(value);
                break;
            case "descriptionOne":
                setDescriptionOne(value);
                break;
            case "descriptionTwo":
                setDescriptionTwo(value);
                break;
            case "discount":
                setDiscount(value);
                break;
            case "loyaltyPoint":
                setLoyaltyPoint(value);
                break;
            case "spent":
                setSpent(value);
                break;
            case "bonusloyalty":
                setBonusloyalty(value);
                break;
                case "skyCoins":
                setSkyCoins(value);
                break;
            default:
                break;
        }
    };
    const validateFields = () => {
        const errors = {};
        const nameRegex = /^[A-Za-z\s]+$/;
        if (!name?.trim()) {
            errors.name = "Name is required";
        } else if (!nameRegex.test(name)) {
            errors.name = "Name can only contain letters";
        }
        const priceRegex = /^\d+(\.\d{1,2})?$/;
        if (!eligibilityCriteria || String(eligibilityCriteria).trim() === "") {
            errors.eligibilityCriteria = "EligibilityCriteria is required";
        } else if (!priceRegex.test(String(eligibilityCriteria))) {
            errors.eligibilityCriteria = "EligibilityCriteria must be a valid number (e.g., 100 or 100.50)";
        }
        const discountRegex = /^(100(\.0{1,2})?|(\d{1,2})(\.\d{1,2})?)$/;

        if (!discount || String(discount).trim() === "") {
            errors.discount = "Party Activity Discount is required";
        } else if (!discountRegex.test(String(discount))) {
            errors.discount = "Discount must be a valid percentage (0 - 100)";
        } else if (parseFloat(discount) < 0 || parseFloat(discount) > 100) {
            errors.discount = "Discount must be between 0 and 100";
        }

        const loyaltyRegex = /^\d+(\.\d{1,2})?$/;
        if (!loyaltyPoint || String(loyaltyPoint).trim() === "") {
            errors.loyaltyPoint = "Earned Loyalty Point is required";
        } else if (!loyaltyRegex.test(String(loyaltyPoint))) {
            errors.loyaltyPoint = "Earned Loyalty Point must be a valid number";
        }

         const bonusloyaltyRegex = /^\d+(\.\d{1,2})?$/;
        if (!bonusloyalty || String(bonusloyalty).trim() === "") {
            errors.bonusloyalty = "Bonus Loyalty Points is required";
        } else if (!bonusloyaltyRegex.test(String(loyaltyPoint))) {
            errors.bonusloyalty = "Bonus Loyalty Points must be a valid number";
        }
        if (!spent) {
            errors.spent = "Spent is required";
        } else if (!priceRegex.test(spent)) {
            errors.spent = "Spent must be a valid number";
        }

         if (!skyCoins || String(skyCoins).trim() === "") {
            errors.skyCoins = "SkyCoins is required";
        } else if (!discountRegex.test(String(skyCoins))) {
            errors.skyCoins = "skyCoins must be a valid percentage (0 - 100)";
        } else if (parseFloat(skyCoins) < 0 || parseFloat(discount) > 100) {
            errors.skyCoins = "SkyCoins must be between 0 and 100";
        }

        // if (!logo) {
        //     errors.logo = "Card Image is required";
        // }

        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const addMemberShipData = async () => {
        if (!validateFields()) return;

        // if (!taxRateData) {
        //     toast.error("Tax Rate is required");
        //     return;
        // }

        const formData = new FormData();
        formData.append("company_id", 1);
        formData.append("name", name);
        formData.append("eligibility_criteria", eligibilityCriteria);
        formData.append("additional_discount", discount);

        formData.append("is_active", true);
        formData.append("loyalty_point", loyaltyPoint)
        formData.append("play_point_spent", spent)

        formData.append("duration", parseInt(1));
        formData.append("tax_rate_id", parseInt(1));
        formData.append("additional_loyalty_point", bonusloyalty || 0);
        formData.append("additional_point_percentage",skyCoins || 0)
        // formData.append("description_two", descriptionTwo);

        if (logo instanceof File) {
            formData.append("logo", logo);
        } else {
            console.warn("Logo is not a valid File object", logo);
        }

        try {
            const response = await API.addMemberShip(formData);
            if (response?.status === 200) {
                toast.success(response?.data?.message || "Membership created successfully!");
                setTimeout(() => window.location.reload(), 2000);
                //window.location.replace("/PlayPoint");
            } else {
                toast.error(response?.data?.message || "Membership not added. Please try again later.");
            }
        } catch (error) {
            if (error.response?.status === 403) {
                window.location.replace("/Login");
            }
            toast.error(error.message);
        }
    };

    const handleLogoChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const allowedFormats = ['image/jpeg', 'image/png', 'image/gif'];
            const maxSize = 5 * 1024 * 1024;

            if (!allowedFormats.includes(file.type)) {
                toast.error("Only JPG, PNG, and GIF formats are allowed.");
                return;
            }

            if (file.size > maxSize) {
                toast.error("File size must be 5MB or smaller.");
                return;
            }
            setError((prevErrors) => {
                const updatedErrors = { ...(prevErrors || {}) };
                delete updatedErrors.logo;
                return updatedErrors;
            });
            setLogo(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setSelectedDuration(value);
        setError((prevErrors) => {
            const updatedErrors = { ...(prevErrors || {}) };
            delete updatedErrors.selectedDuration;
            delete updatedErrors.logo;
            return updatedErrors;
        });
    };

    const handleTaxRateChange = (value) => {
        setTaxRateData(value);
    };

    const handleError = (error) => {
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const getDurationList = async () => {
        try {
            const response = await APIS.getDurationData({ is_active: true });
            setDuration(response?.data?.data?.rows);
        } catch (error) {
            setError((prevErrors) => ({
                ...prevErrors,
                duration: "Failed to fetch duration data.",
            }));
            if (error.response.status === 403) {
                window.location.replace("/Login");
            }
            handleError(error);
        }
    };

    const handleCancelEdit = () => {
        setName('');
        setEligibilityCriteria('');
        setSelectedDuration('');
        setTaxRateData('');
        setDescriptionOne('');
        setDescriptionTwo('');
        setLoyaltyPoint('');
        setDiscount('');
        setLogo('');
        setSpent('');
        setLogoPreview(null);
        setError({});
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        await addMemberShipData();
    };

    return (
        <div>
            <div>
                {/* <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Membership</h4>
                            <div className="forms-sample">
                                <div className="row">
                                    <div className="col-md-4">
                                        <label>Name <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={name}
                                            onChange={(e) => handleFieldChange(e, "name")}
                                        />
                                        {error?.name && <span className="text-danger" style={{fontSize:"12px"}}>{error.name}</span>}
                                    </div>

                                    <div className="col-md-4">
                                        <label>Eligibility Criteria <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={eligibilityCriteria}
                                            onChange={(e) => handleFieldChange(e, "eligibilityCriteria")}
                                        />
                                        {error?.eligibilityCriteria && <span className="text-danger" style={{fontSize:"12px"}}>{error.eligibilityCriteria}</span>}
                                    </div>
                                    <div className="col-md-4">
                                        <label>Party Activity Discount (%) <span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={discount}
                                            onChange={(e) => handleFieldChange(e, "discount")}
                                        />
                                        {error?.discount && <span className="text-danger" style={{fontSize:"12px"}}>{error.discount}</span>}
                                    </div>
                                </div>

                                <div className="row mt-3">
                                    <div className="col-md-4">
                                        <label>Earned LoyalityPoints<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={loyaltyPoint}
                                            onChange={(e) => handleFieldChange(e, "loyaltyPoint")}
                                        />
                                        {error?.loyaltyPoint && <span className="text-danger" style={{fontSize:"12px"}}>{error.loyaltyPoint}</span>}
                                    </div>

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="name">SkyCoins Spent <span style={{ color: "red" }} >*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtSpent"
                                                placeholder="SkyCoins Spent"
                                                value={spent}
                                                onChange={(e) => handleFieldChange(e, "spent")}
                                            />
                                            {error?.spent && (
                                                <span className="text-danger" style={{fontSize:"12px"}}>
                                                    {error.spent}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label>Bonus Loyalty Points<span style={{ color: "red" }} >*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={bonusloyalty}
                                            onChange={(e) => handleFieldChange(e, "bonusloyalty")}
                                        />
                                        {error?.bonusloyalty && <span className="text-danger" style={{fontSize:"12px"}}>{error.bonusloyalty}</span>}
                                    </div>
                                </div>
                                <div className="row">
                                      <div className="col-md-4">
                                        <label>SkyCoins(%)<span style={{ color: "red" }}>*</span></label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={skyCoins}
                                            onChange={(e) => handleFieldChange(e, "skyCoins")}
                                        />
                                        {error?.skyCoins && <span className="text-danger" style={{fontSize:"12px"}}>{error.skyCoins}</span>}
                                    </div>
                                    <div className="col-md-4">
                                        <label>Upload Card Image </label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={handleLogoChange}
                                        />

                                        {error?.logo && <span className="text-danger" style={{fontSize:"12px"}}>{error.logo}</span>}
                                    </div>
                                    <div className="col-md-4">
                                        {logoPreview && (
                                            <div className="mt-2">
                                                <img src={logoPreview || "No Image Available"} alt="Logo Preview" style={{ width: 100, height: 100, objectFit: 'cover' }} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="mt-4">

                                    <button className="btn btn-primary me-2" onClick={handleSubmit}>Submit</button>
                                    <button className="btn btn-light" onClick={handleCancelEdit}>Cancel</button>

                                </div>
                            </div>
                        </div>

                    </div>
                </div> */}
            </div>
            <MemberShipList />
            <ToastContainer />
        </div>
    );
};

export default MemberShip;
